import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const addGlobalBlacklistTerm = unaryRpc({
  name: "addGlobalBlacklistTerm",
  input: z.object({ term: z.string().min(1) }),
  output: z.object({
    id: z.string(),
    term: z.string(),
    createdBy: z.string(),
    createdAt: z.string(),
  }),
});
